/**
 * Sigla din antet, cand omul e in Settings, il duce inapoi la ultima pagina
 * din afara setarilor (acelasi modul, acelasi ecran, acelasi query). Adresa se
 * tine in memorie si in sessionStorage, ca sa treaca de un refresh. Fara una,
 * sigla duce la start.
 */
const KEY = 'od.settingsReturn'
let remembered: string | null = null

/** `/app/settings/...` sau `/settings/...` (cu sau fara basepath). */
export function isSettingsPath(pathname: string): boolean {
  const path = pathname.replace(/^\/app(?=\/|$)/, '').replace(/^\/+/, '')
  return path === 'settings' || path.startsWith('settings/')
}

/** Adresa intreaga, cu `/app` in fata: `pathname` poate veni fara basepath. */
function full(pathname: string, search: string, hash: string): string {
  const p = pathname.startsWith('/app/') || pathname === '/app' ? pathname : '/app' + (pathname.startsWith('/') ? pathname : '/' + pathname)
  return p + (search ?? '') + (hash ?? '')
}

/** Se cheama la fiecare schimbare de adresa; tine minte doar ce e in afara setarilor. */
export function rememberLocation(pathname: string, search = '', hash = ''): void {
  if (isSettingsPath(pathname)) return
  remembered = full(pathname, search, hash)
  try {
    window.sessionStorage.setItem(KEY, remembered)
  } catch {
    /* fara sessionStorage ramane memoria */
  }
}

/** Unde duce sigla din Settings: ultima adresa din afara, sau null (start). */
export function settingsReturnTarget(): string | null {
  if (remembered !== null) return remembered
  try {
    const stored = window.sessionStorage.getItem(KEY)
    if (stored && stored.startsWith('/app') && !isSettingsPath(stored.split(/[?#]/)[0] ?? '')) {
      remembered = stored
      return stored
    }
  } catch {
    /* nimic */
  }
  return null
}

/** Doar pentru probe. */
export function resetSettingsReturn(): void {
  remembered = null
  try {
    window.sessionStorage.removeItem(KEY)
  } catch {
    /* nimic */
  }
}
